<template>
<div>
  
<v-data-table
    :headers="overallSummaryHeaders"
    class="elevation-1"
    :items="overallsummary"
    :rows-per-page-items="[25, 50, 100, 250]"
    item-key="name"
    align-center
    style="cursor: pointer"
  >
    <template v-slot:items="props">
      <td @click="viewInfo(props.item)" class="text-xs-center">{{formatDate(props.item.date)}}</td>
      <td @click="viewInfo(props.item)"
          class="text-xs-center red--text"
        >{{props.item.debit|currency}}</td>
        <td @click="viewInfo(props.item)"
          class="text-xs-center green--text"
        >{{props.item.credit|currency}}</td>
    </template>
    <!-- Custom Row count and Paging text -->
    <template
      v-slot:pageText="props"
    >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    <!-- No data Dispalay -->
    </v-data-table>
<v-dialog persistent v-model="viewBillingModal" max-width="1200px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">VIEW BILLING FOR {{date}}</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
           <v-spacer></v-spacer>
        <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="billingHistory"
    :fields="exportFields"
    worksheet="export"
    :name="'billingOverview_'+new Date(editedItem.date).toLocaleString('en-us', { month: 'short' })+'_'+new Date(editedItem.date).getFullYear()+'.xls'">
    Export to Excel
</download-excel></v-btn>
        </v-toolbar>
       
        <v-card-text>
              
               <v-data-table
    :headers="detailHeaders"
    class="elevation-1"
    :items="billingHistory"
    :rows-per-page-items="[25, 50, 100, 250]"
    item-key="id"
    align-center
    style="cursor: pointer"
  >
    <template v-slot:items="props">
      <!-- <td><v-icon class="text-xs-center" medium @click="getReport(props.item)">get_app</v-icon></td> -->
      <td class="text-xs-center" @click="viewDetailedInfo(props.item)">{{formatDate(props.item.date)}}</td>
      <td class="text-xs-center" @click="viewDetailedInfo(props.item)" v-if="props.item.customerOrganisationId!==null">{{props.item.customerOrganisation.name}}</td>
      <td class="text-xs-center" @click="viewDetailedInfo(props.item)" v-else></td>
      <td class="text-xs-center" @click="viewDetailedInfo(props.item)" v-if="props.item.supplierOrganisationId!==null">{{props.item.supplierOrganisation.name}}</td>
      <td class="text-xs-center" @click="viewDetailedInfo(props.item)" v-else></td>
      <!-- <td class="text-xs-center" @click="viewDetailedInfoForCustomer(props.item)">{{props.item.description}}</td> -->
      <td @click="viewDetailedInfo(props.item)"
          class="text-xs-center red--text"
          v-if="props.item.transactionType!=='Sales'&&props.item.transactionType!=='Loan'"
        >{{props.item.amount | currency}}</td>
        <td class="text-xs-center" v-else></td>
        <td @click="viewDetailedInfo(props.item)"
          class="text-xs-center green--text"
          v-if="props.item.transactionType==='Sales'||props.item.transactionType==='Loan'"
        >{{props.item.amount | currency}}</td>
        <td class="text-xs-center" v-else></td>
    </template>
    <!-- Custom Row count and Paging text -->
    <template
      v-slot:pageText="props"
    >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    <!-- No data Dispalay -->
    </v-data-table>
              <!-- <v-flex xs12 sm6 md6>
                <v-select
                  class="text-xs-center"
                  label="Network"
                  :items="locationnetworks"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.locationNetworkId"
                ></v-select>
              </v-flex>-->
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="viewBillingModal=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="viewDetailedBillingModal" max-width="1200px">
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">VIEW BILLING FOR {{date}}</h1>
        </v-toolbar>
        <v-toolbar flat color="white">
           <v-spacer></v-spacer>
        <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="customerTransactions"
    :fields="exportFields"
    worksheet="export"
    :name="'billingOverview_'+new Date(editedItem.date).getTime()+'.xls'">
    Export Transactions to Excel
</download-excel></v-btn>
<v-btn v-if="itemisedBill.length>0" round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="itemisedBill"
    :fields="serviceAccountExportFields"
    worksheet="export"
    :name="'serviceAccounts.xls'">
    Export Service Accounts to Excel
</download-excel></v-btn>
        </v-toolbar>
       
        <v-card-text>
              
               <v-data-table
    :headers="headers"
    class="elevation-1"
    :items="customerTransactions"
    :rows-per-page-items="[25, 50, 100, 250]"
    item-key="name"
    align-center
  >
    <template v-slot:items="props">
      
      <td class="text-xs-center" @click="viewDetailedInfoForCustomer(props.item)">{{formatDate(props.item.date)}}</td>
      <td class="text-xs-center" @click="viewDetailedInfoForCustomer(props.item)" v-if="props.item.customerOrganisationId!==null">{{props.item.customerOrganisation.name}}</td>
      <td class="text-xs-center" @click="viewDetailedInfoForCustomer(props.item)" v-else></td>
      <td class="text-xs-center" @click="viewDetailedInfoForCustomer(props.item)" v-if="props.item.supplierOrganisationId!==null">{{props.item.supplierOrganisation.name}}</td>
      <td class="text-xs-center" @click="viewDetailedInfoForCustomer(props.item)" v-else></td>
      <td class="text-xs-center" @click="viewDetailedInfoForCustomer(props.item)">{{props.item.description}}</td>
      <td @click="viewDetailedInfoForCustomer(props.item)"
          class="text-xs-center red--text"
          v-if="props.item.transactionType!=='Sales'&&props.item.transactionType!=='Loan'"
        >{{props.item.amount | currency}}</td>
        <td @click="viewDetailedInfoForCustomer(props.item)" class="text-xs-center" v-else></td>
        <td @click="viewDetailedInfoForCustomer(props.item)"
          class="text-xs-center green--text"
          v-if="props.item.transactionType==='Sales'||props.item.transactionType==='Loan'"
        >{{props.item.amount | currency}}</td>
        <td @click="viewDetailedInfoForCustomer(props.item)" class="text-xs-center" v-else></td>
    </template>
    <template
      v-slot:pageText="props"
    >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="viewDetailedBillingModal=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    


     </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
    props:['billingHistory','overallsummary','allGlobalTotals'],
    data() {
    return {
        viewBillingModal: false,
        itemisedBill:[],
        viewDetailedBillingModalByCustomer: false,
        customerTransactions:[],
        viewDetailedBillingModal: false,
        date: null,
        startDay: null,
      endDay: null,
         exportFields: {
        'transactionDate': 'date',
        'customer': 'customerOrganisation.name',
        'supplier': 'supplierOrganisation.name',
        'transactionType': 'transactionType',
        'description': 'description',
            'amount': 'amount'
        },
        detailHeaders:[
        {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        {
          text: "Customer",
          align: "center",
          value: "customerOrganisation.name"
        },
        {
          text: "Supplier",
          align: "center",
          value: "supplierOrganisation.name"
        },
        // {
        //   text: "Description",
        //   align: "center",
        //   value: "description"
        // },
        {
          text: "Debit",
          align: "center",
          value: "amount"
        },
        {
          text: "Credit",
          align: "center",
          value: "amount"
        }
            ],
      headers:[
        {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        {
          text: "Customer",
          align: "center",
          value: "customerId"
        },
        {
          text: "Supplier",
          align: "center",
          value: "supplierId"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Debit",
          align: "center",
          value: "amount"
        },
        {
          text: "Credit",
          align: "center",
          value: "amount"
        }
            ],
            overallSummaryHeaders:[
        {
          text: "Transaction Date",
          align: "center",
          value: "date"
        },
        {
          text: "Debit",
          align: "center",
          value: "amount"
        },
        {
          text: "Credit",
          align: "center",
          value: "amount"
        }
            ],
            editedItem:{
              date: null,
              debit: null,
              credit: null
            },
            serviceAccountExportFields: {
        id: "id",
        node: "location.locationNetwork.locationNode.name",
        network: "location.locationNetwork.name",
        unit: {
          callback: value => {
            if (value.location.locationNetworkSubComplexId !== null) {
              return (
                value.location.unitNo +
                " " +
                value.location.locationNetworkSubComplex.subComplexName
              );
            } else {
              return value.location.unitNo;
            }
          }
        },
        ispName: "packagesIsp.customer.name",
        fnoPackage: "packagesIsp.packagesFno.packageCode",
        pppoeUsername: "pppoeUsername",
        pppoePassword: "pppoePassword",
        initialActivation: {
          callback: value => {
            return this.formatDate(value.initialActivation);
          }
        },
        ispActivation: {
          callback: value => {
            return this.formatDate(value.ispActivationDate);
          }
        },
        ispDeactivation: {
          callback: value => {
            return this.formatDate(value.ispDeactivationDate);
          }
        },
        fnoActivation: {
          callback: value => {
            return this.formatDate(value.fnoActivationDate);
          }
        },
        fnoDeactivation: {
          callback: value => {
            return this.formatDate(value.fnoDeactivationDate);
          }
        },
        fnoPackagePrice: {
          callback: value => {
            if (value.location.locationNetwork.lineRentalIncluded) {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.residentialLineRentalValue
              );
            } else {
              return value.packagesIsp.packagesFno.packageBasePrice;
            }
          }
        },
        billedFrom: {
          callback: value => {
            if (new Date(value.initialActivation) >= new Date(this.startDay)) {
              return this.formatDate(value.initialActivation);
            } else {
              return this.formatDate(this.startDay);
            }
          }
        },
        billedTo: {
          callback: value => {
            if (
              value.fnoDeactivationDate !== null &&
              value.ispDeactivationDate === null &&
              new Date(value.fnoDeactivationDate) <= new Date(this.endDay) &&
              new Date(value.fnoDeactivationDate) >= new Date(this.startDay)
            ) {
              return this.formatDate(value.fnoDeactivationDate);
            } else if (
              value.fnoDeactivationDate === null &&
              value.ispDeactivationDate !== null &&
              new Date(value.ispDeactivationDate) <= new Date(this.endDay) &&
              new Date(value.ispDeactivationDate) >= new Date(this.startDay)
            ) {
              return this.formatDate(value.ispDeactivationDate);
            } else if (
              value.fnoDeactivationDate !== null &&
              value.ispDeactivationDate !== null &&
              (new Date(value.fnoDeactivationDate) >=
                new Date(value.ispDeactivationDate) &&
                new Date(value.fnoDeactivationDate) <= new Date(this.endDay) &&
                new Date(value.fnoDeactivationDate) >= new Date(this.startDay))
            ) {
              return this.formatDate(value.fnoDeactivationDate);
            } else if (
              value.fnoDeactivationDate !== null &&
              value.ispDeactivationDate !== null &&
              (new Date(value.fnoDeactivationDate) <=
                new Date(value.ispDeactivationDate) &&
                new Date(value.ispDeactivationDate) <= new Date(this.endDay) &&
                new Date(value.ispDeactivationDate) >= new Date(this.startDay))
            ) {
              return this.formatDate(value.ispDeactivationDate);
            } else {
              return this.formatDate(this.endDay);
            }
          }
        },
        "Data Activation Fee": {
          callback: value => {
            if (
              new Date(value.initialActivation) <= new Date(this.endDay) &&
              new Date(value.initialActivation) >= new Date(this.startDay)
            ) {
              return value.location.locationNetwork.activationFeeAmount;
            } else {
              return 0;
            }
          }
        },
        "VAS Billed": {
          callback: value => {
            return this.calcuateRecurringBills(value);
          }
        }
      }
    }
},
watch:{
  '$route.query.billingDate': {
    immediate: true,
    handler (value) {
      if(this.date!==null) {
      // (this.startDay = new Date(this.setDate)),
      let selectedDate = new Date(this.editedItem.date);
      (this.startDay = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth() - 1,
        26
      )),
        (this.endDay = new Date(
          this.startDay.getFullYear(),
          this.startDay.getMonth() + 1,
          25
        ));
      let date = new Date(
        this.startDay.getFullYear(),
        this.startDay.getMonth(),
        0
      );
      
    }
    }
  }
},
    methods:{
      calcuateRecurringBills(item) {
      // this.getStart(item.fnoActivationDate, item.ispActivationDate);
      if (new Date(item.initialActivation) >= new Date(this.startDay)) {
        this.startDate = new Date(item.initialActivation);
      } else {
        this.startDate = new Date(this.startDay);
      }

      if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate === null
      ) {
        this.endDate = new Date(this.endDay);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate === null &&
        new Date(item.fnoDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.fnoDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.fnoDeactivationDate);
      } else if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate !== null &&
        new Date(item.ispDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.ispDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.ispDeactivationDate);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate !== null
      ) {
        if (
          new Date(item.fnoDeactivationDate) >=
          new Date(item.ispDeactivationDate)
        ) {
          this.endDate = new Date(item.fnoDeactivationDate);
        } else {
          this.endDate = new Date(item.ispDeactivationDate);
        }
      }
      // this.getEnd(item.fnoDeactivationDate, item.ispDeactivationDate);
      let setDate = new Date(this.setDate);
      // this.daysInCurrentMonth = new Date(
      //   setDate.getFullYear(),
      //   setDate.getMonth() + 1,
      //   0
      // ).getDate();
      console.log(this.endDay)
      this.daysInCurrentMonth = Math.round(
        Math.abs(this.endDay.getTime() - this.startDay.getTime()) / 86400000
      );
      this.startDate = new Date(this.startDate);
      this.endDate = new Date(this.endDate);
      let billedAmount = item.packagesIsp.packagesFno.packageBasePrice;
      this.billedDays = Math.round(
        Math.abs(this.endDate.getTime() - this.startDate.getTime()) / 86400000
      );
      if (item.location.locationNetwork.lineRentalIncluded) {
        billedAmount =
          billedAmount - item.location.locationNetwork.residentialLineRentalValue;
      }

      return (
        Math.round(
          (this.billedDays / this.daysInCurrentMonth) * billedAmount * 100
        ) / 100
      );
    },
        viewInfo(item){
          this.editedItem = Object.assign({}, item);
          this.date= new Date(this.date)
            this.date=this.formatDate(this.editedItem.date);
            if(this.date !==null){
        const route = {
        name: this.$route.name
      };
        route.query = { billingDate: this.editedItem.date };
      this.$router.push(route);
      }
            this.viewBillingModal=true
        },
        viewDetailedInfo(item){
          let date = this.$route.query.billingDate
          this.customerTransactions = this.allGlobalTotals.filter(function (el) {
  return el.customerOrganisationId === item.customerOrganisationId &&
  el.supplierOrganisationId === item.supplierOrganisationId && 
  el.date === date
});
          this.editedItem = Object.assign({}, item);
            // this.date=this.formatDate(this.editedItem.date);
      //       if(this.date !==null){
      //   const route = {
      //   name: this.$route.name
      // };
      //   route.query = { billingDate: this.editedItem.date };
      // this.$router.push(route);
      // }
            this.viewDetailedBillingModal=true
            if(item.customerOrganisationId!==null){
              Api()
            .get('/serviceAccounts/billing/'+item.customerOrganisationId,{
                params:{
                    billingDate: this.$route.query.billingDate
                }
            })
            .then(response=>{
                this.itemisedBill=response.data
            })
            } else {
              Api()
            .get('/serviceAccounts/billing/'+item.supplierOrganisationId,{
                params:{
                    billingDate: this.$route.query.billingDate
                }
            })
            .then(response=>{
                this.itemisedBill=response.data
            })
            }
            
        },
        viewDetailedInfoForCustomer(item){
      
      this.viewDetailedBillingModalByCustomer=true
    },
        formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    
    remove(item){
      Api()
      .put('/billingHistorySummary/'+item.id,{
        isActive: false
      })
      .then(
        Api()
        .get('/billingHistory/byBillingBatchNumber/'+item.billingBatchNumber)
        .then(response=>{
          for (let i=0;i<response.data.length;i++){
            Api()
            .put('/billinghistory/'+response.data[i].id,{
              isActive: false
            })
          }
        })
      )
    }
    }
    }
</script>
